<template>
  <div data-testid="multi-select-months">
    <div @click.stop="dialog = true">
      <v-text-field
        ref="element"
        :prepend-inner-icon="prependinnericon"
        dense
        outlined
        :label="label || 'Select Months'"
        clearable
        :error-messages="error"
        @keypress="dialog = true"
        @click:clear.stop="clearSelection"
        :hide-details="hidedetails"
        :disabled="disabled"
        data-testid="multi-select-months__text-field"
        :append-icon="appendicon"
        :class="roundedClass"
        class="pt-1"
      ></v-text-field>
    </div>
    <v-dialog max-width="290px" v-model="dialog" transition="dialog-transition" data-testid="multi-select-months__dialog">
      <v-card>
        <!-- <v-card-text class="pa-0">
            <div v-if="selectedMonths.length" class="selected-months pa-0">
                <h3>Selected Months:</h3>
                <ul>
                <li v-for="(month, index) in selectedMonths" :key="index" class="month-item">
                    {{ month }}
                    <v-btn icon @click="removeMonth(month)">
                    <v-icon>mdi-close</v-icon>
                    </v-btn>
                </li>
                </ul>
            </div>
            <br>
        </v-card-text> -->
        <v-card-text class="pa-0">
          <v-date-picker
            elevation="0"
            v-model="tempDate"
            color="primary white--text"
            :min="min"
            :max="max"
            type="month"
            @input="toggleMonthSelection"
            :readonly="readonly"
            :multiple="multiple"
            data-testid="multi-select-months__date-picker"
          >

            <v-spacer></v-spacer>
            <div class="d-flex gap-3">
              <v-btn text @click="dialog = false" class="secondaryBtn" data-testid="multi-select-months__close-button"><span>{{ closeText }}</span></v-btn>
              <v-btn
                color="primary"
                @click="applySelection"
                data-testid="multi-select-months__ok-button"
              ><span>{{ okText }}</span></v-btn>
            </div> 
          </v-date-picker>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      selectedMonths: [],  // Store multiple months
      tempDate: null,        // Temporary date for date picker selection
    };
  },
  props: {
    error: [String, Array],
    label: {
        type:String,
        default:'Select Month(s)',

    },
    value: {
        type:Array,
        default: () => [],
    },
    min: {
        type:String,
        default:''
    },
    max: {
        type:String,
        default:''
    },
    hidedetails: {
        type:Boolean,
        default:false
    },
    disabled: {
        type:Boolean,
        default:false
    },
    readonly: {
        type:Boolean,
        default:false
    },
    appendicon: {
        type: String,
        default: 'mdi-chevron-down'
    },
    roundedClass: {
        type: String,
        default: 'rounded-lg'
    },
    prependinnericon: {
        type: String,
        default: 'mdi-calendar-range'
    },
    multiple: {
        type: Boolean,
        default: true
    },
    closeText: {
        type: String,
        default: 'Close'
    },
    okText: {
        type: String,
        default: 'Ok'
    },
  },
  methods: {
    setValue() {
      if (this.multiple) {
        // Filter out null/undefined values
        this.selectedMonths = Array.isArray(this.value) ? this.value.filter(v => v != null) : [];
      } else {
        this.selectedMonths = this.value && this.value.length > 0 && this.value[0] != null ? [this.value[0]] : [];
      }
    },
    toggleMonthSelection(month) {
        if (this.multiple) {
            // Multiple selection mode
            const monthString = Array.isArray(month) ? month[month.length - 1] : month;
            // Ignore null/undefined values
            if (monthString == null) return;
            
            if (this.selectedMonths.includes(monthString)) {
                this.selectedMonths = this.selectedMonths.filter((m) => m !== monthString);
            } else {
                this.selectedMonths.push(monthString);
            }
        } else {
            // Single selection mode - ignore null values
            if (month != null) {
                this.selectedMonths = [month];
            }
        }
    },
    applySelection() {
      this.dialog = false;
      this.updateValue();
    },
    updateValue() {
      // Filter out any null/undefined values before emitting
      const cleanedMonths = this.selectedMonths.filter(m => m != null);
      this.$emit("input", cleanedMonths);
      this.$emit("change", cleanedMonths);
    },
    clearSelection() {
      this.selectedMonths = [];
      this.updateValue();
    },
    removeMonth(month) {
      this.selectedMonths = this.selectedMonths.filter((m) => m !== month);
    },
  },
  computed: {
    formattedRangevalue() {
      return this.selectedMonths
        .map((month) => this.$nova.formatDate(month, "MMM YYYY"))
        .join(", ");
    },
  },
  watch: {
    value() {
      this.setValue();
    },
    dialog(){
        if(this.dialog === true){
            if (this.multiple) {
                // Filter out null/undefined values when setting tempDate
                this.tempDate = Array.isArray(this.value) ? this.value.filter(v => v != null) : [];
            } else {
                this.tempDate = this.value && this.value.length > 0 && this.value[0] != null ? this.value[0] : null;
            }
            this.setValue()
        }
    }
  },
  created() {
    this.setValue();
  },
};
</script>

<style scoped>
.selected-months {
  margin-top: 20px;
}
.selected-months ul {
  display: flex;
  flex-wrap: wrap; /* Allows items to wrap to the next line */
  padding: 0;
  margin: 0;
  list-style-type: none; /* Remove default list styling */
}
.month-item {
  display: flex;
  align-items: center;
  margin: 4px 8px; /* Spacing around items */
  padding: 4px 8px;
  background-color: #e0f7fa; /* Background color for items */
  border-radius: 4px;
  font-size: 0.9em;
}
</style>
